import React from 'react'
import type { FC } from 'react'
import { useTheme } from '@mui/material'
import CloseButton from 'redesign/components/atoms/Buttons/CloseButton'
import SnackbarBase from 'redesign/components/atoms/snackbar-base/snackbar-base'
import type { ToastProps } from './types'

const Toast: FC<ToastProps> = ({ onClose, ...rest }) => {
  const { palette } = useTheme()

  return (
    <SnackbarBase
      onClose={onClose}
      {...rest}
      action={<CloseButton onClick={onClose} color={palette.textLight.secondary} />}
    />
  )
}

export default Toast
